import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

const MobileDeviceMediaQueryThreshold = '(max-width: 768px)';

@Injectable({
  providedIn: 'root',
})
export class BreakpointService {
  isMobile$: Observable<boolean>;
  isDesktop$: Observable<boolean>;
  private _isMobile = new BehaviorSubject<boolean>(false);
  private _isDesktop = new BehaviorSubject<boolean>(true);

  get isMobile(): boolean {
    return this._isMobile.value;
  }

  get isDesktop(): boolean {
    return this._isDesktop.value;
  }

  constructor(private breakpointObserver: BreakpointObserver) {
    this.initObserver();
  }

  initObserver(): void {
    this.isMobile$ = this.breakpointObserver
      .observe([MobileDeviceMediaQueryThreshold])
      .pipe(
        map((result) => result.matches),
        tap((matches) => {
          this._isMobile.next(matches);
          this._isDesktop.next(!matches);
        }),
        shareReplay(1),
      );
    this.isDesktop$ = this._isDesktop.asObservable();
  }

  observe(query: string | string[]): Observable<boolean> {
    return this.breakpointObserver.observe(query)
      .pipe(
        map((result) => result.matches),
        distinctUntilChanged(),
        shareReplay(1),
      );
  }
}
